<template>
  <LibraryCard
    :internal-link="true"
    :url="strategyUrl"
    :updated-time="strategy.updated_at"
    :show-timestamp="showTimestamp"
    :new-window="shared">
    <div class="strategy-card-body remove-resource-btn-container">
      <RemoveResourceButton
        v-if="removable && !shared"
        :resource-id="contentUuid"
        :collection-id="collectionUuid"
        :type="resourceType" />
      <div class="media">
        <div class="media-left">
          <img class="strategy-image media-object" :src="strategy.image_url">
        </div>
        <div class="media-body">
          <h4 class="media-heading">{{ strategy.title }}</h4>
          <div class="text-muted-dark"><WikiText :text="strategy.description" :plaintext="true" /></div>
        </div>
      </div>
    </div>
    <template v-slot:footer-right>
      <div v-if="showResourceCount" class="resource-count">
        <span class="material-icons-outlined text-lg">file_download</span>
        <span class="count">{{ strategy.resource_count }}</span>
      </div>
      <span v-if="studentName" class="fs-block">{{ studentName }}</span>
    </template>
  </LibraryCard>
</template>

<script>
import WikiText from '@/components/WikiText'
import LibraryCard from '@/components/library/LibraryCard'
import RemoveResourceButton from '@/components/library/RemoveResourceButton'
import { CONTENT_TYPES } from '@/util/access_visibility'

export default {
  name: 'LibraryStrategyCard',
  components: {
    LibraryCard,
    WikiText,
    RemoveResourceButton
  },
  props: {
    strategy: {
      type: Object,
      required: true
    },
    studentName: {
      type: String,
      required: false
    },
    contentUuid: {
      type: String,
      required: false
    },
    collectionUuid: {
      type: String,
      required: false
    },
    shared: {
      type: Boolean,
      default: false
    },
    saved: {
      type: Boolean,
      default: true
    },
    removable: {
      type: Boolean,
      default: true
    },
    showTimestamp: {
      type: Boolean,
      default: true
    },
    showResourceCount: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      resourceType: CONTENT_TYPES.SAVED_STRATEGY
    }
  },
  computed: {
    strategyUrl() {
      if (!this.saved) {
        return { name: 'StrategyDetailPage', params: { slugOrUuid: this.contentUuid } }
      }
      return this.shared
        ? { name: 'SharedStrategyDetailPage', params: { uuid: this.contentUuid } }
        : { name: 'SavedStrategyPage', params: { uuid: this.contentUuid } }
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
@import '@/components/library/library_styles.less';
.strategy-card-body {
  overflow: hidden;
  height: 130px;
  padding: 20px;
  line-height: 20px;
  padding-bottom: 0px;
  margin-bottom: 12px;
  font-size: var(--text-md);
  &:hover, :focus {
    h4 {
      color: @link-hover-color;
    }
  }
  h4 {
    font-weight: bold;
    color: @link-color;
    margin-top: 0;
    margin-bottom: 2px;
  }
  .text-muted-dark {
    margin-top: 12px;
  }
  .strategy-image {
    height: auto;
    width: 60px;
  }
  .media {
    margin: 0;
  }
}
.resource-count {
  display: flex;
  align-items: flex-end;
  font-weight: var(--font-bold);
  line-height: 1.1;
}
</style>
